/**
 * Cool Menu
 * @author      delphinpro <delphinpro@gmail.com>
 * @license     licensed under the MIT license
 */

import $ from 'jquery';


export default class CoolMenu {
  constructor(options) {
    let blockClass = 'cool-menu';
    this.data      = [];
    this.level     = 0;
    this.opt       = {
      source           : null,
      container        : document.body,
      $button          : null,
      delimiter        : false,
      headerText       : 'Menu',
      rootClass        : blockClass,
      stateOpenClass   : `${blockClass}_open`,
      scrollPaneClass  : `${blockClass}__scroll-pane`,
      closerClass      : `${blockClass}__closer`,
      headerClass      : `${blockClass}__header`,
      headerInnerClass : `${blockClass}__header-in`,
      headerActiveClass: `${blockClass}__header_active`,
      menuClass        : `${blockClass}__menu`,
      menuItemClass    : `${blockClass}__item`,
      menuLinkClass    : `${blockClass}__link`,
      menuNestedClass  : `${blockClass}__nested`,
      backdropClass    : `${blockClass}-backdrop`,
      buttonOpenClass  : `open`,
      bodyOpenClass    : `is-open-menu`,
      ...options,
    };

    this.headers = [this.opt.headerText];

    this.$coolMenu   = $('<div>', {'class': this.opt.rootClass});
    this.$scrollPane = $('<div>', {'class': this.opt.scrollPaneClass});
    this.$header     = $('<div>', {'class': this.opt.headerClass});
    this.$headerIn   = $('<div>', {'class': this.opt.headerInnerClass});
    this.$closer     = $('<div>', {'class': this.opt.closerClass});
    this.$backdrop   = $('<div>', {'class': this.opt.backdropClass});

    this.updateHeaderText();
    this.loadData();
    this.attachEvents();
    this.render();
  }

  updateHeaderText() {
    this.$headerIn.text(this.headers[this.headers.length - 1]);
  }

  addHeaderText(text) {
    this.headers.push(text);
  }

  removeHeaderText() {
    this.headers.pop();
  }

  loadData() {
    this.opt.source.forEach(item => {
      let $item = $(item);
      this.data = [
        ...this.data,
        ...this.loadDataFromHtml($item),
      ];
    });
  }

  loadDataFromHtml($menu) {
    let list = [];
    $menu.children().each((index, element) => {
      let $li  = $(element);
      let $a   = $li.find('> a');
      let item = {
        text    : $.trim($a.text()),
        link    : $a.attr('href'),
        children: false,
      };
      if ($li.find('ul:first').length) {
        item.children = this.loadDataFromHtml($li.find('ul:first'));
      }
      list.push(item);
    });
    return list;
  }

  toggleMenu(show) {
    if (this.opt.$button) {
      this.opt.$button.toggleClass(this.opt.buttonOpenClass, show);
    }
    this.$coolMenu.toggleClass(this.opt.stateOpenClass, show);
    $(document.body).toggleClass(this.opt.bodyOpenClass, show);
  }

  attachEvents() {
    this.$coolMenu.on('click.coolMenu', 'a', e => {
      let children = $(e.target).data('children');

      if (children) {
        e.preventDefault();
        this.level++;

        this.renderLevel(children);

        this.addHeaderText($(e.target).text());
        this.updateHeaderText();
        this.$header.addClass(this.opt.headerActiveClass);
        if (this.$scrollPane.animate) {
          this.$scrollPane.animate({'left': '-=100%'});
        } else {
          this.$scrollPane.css({'left': '-=320px'});
        }
      }
    });

    this.$coolMenu.on('click.coolMenu', `.${this.opt.headerActiveClass}`, e => {
      e.preventDefault();

      this.level--;

      if (this.level >= 0) {
        if (this.$scrollPane.animate) {
          this.$scrollPane.animate({'left': '+=100%'}, 300, () => {
            this.$coolMenu.find(`.${this.opt.menuClass}`).filter(':last').remove();
            this.$header.toggleClass(this.opt.headerActiveClass, this.level !== 0);
            this.removeHeaderText();
            this.updateHeaderText();
          });
        } else {
          this.$scrollPane.css({'left': '+=320px'});
          this.$coolMenu.find(`.${this.opt.menuClass}`).filter(':last').remove();
          this.$header.toggleClass(this.opt.headerActiveClass, this.level !== 0);
          this.removeHeaderText();
          this.updateHeaderText();
        }
      } else {
        this.level = 0;
      }
    });

    this.$backdrop.on('click.coolMenu', e => {
      this.toggleMenu(false);
    });

    this.$closer.on('click.coolMenu', e => {
      this.toggleMenu(false);
    });

    if (this.opt.$button) {
      this.opt.$button.on('click.coolMenu', e => {
        e.preventDefault();
        let stateOpen = this.opt.$button.hasClass(this.opt.buttonOpenClass);
        this.toggleMenu(!stateOpen);
      });
    }
  }

  renderLevel(items) {
    let $level = $('<ul>', {'class': this.opt.menuClass});

    items.forEach(item => {
      let $item = $('<li>', {'class': this.opt.menuItemClass});

      let $a = $('<a>', {
        'class': this.opt.menuLinkClass,
        href   : item.link,
        text   : item.text,
      });

      $a.data('children', item.children);
      $a.appendTo($item);

      if (item.children) {
        let $nested = $('<span>', {
          'class': this.opt.menuNestedClass,
          // href   : item.link,
          html   : `<span>${item.children.length}</span>`,
        });
        $nested.data('children', item.children);
        $nested.appendTo($item);
      }

      $item.appendTo($level);
    });

    $level.appendTo(this.$scrollPane);
  }

  render() {
    this.renderLevel(this.data);
    this.$closer.appendTo(this.$header);
    this.$headerIn.appendTo(this.$header);
    this.$header.appendTo(this.$coolMenu);
    this.$scrollPane.appendTo(this.$coolMenu);
    this.$backdrop.appendTo(this.opt.container);
    this.$coolMenu.appendTo(this.opt.container);
  }
}



// WEBPACK FOOTER //
// ./source/js/components/CoolMenu.js